export const US_STATE_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const US_TERRITORY_CODES = ['AS', 'GU', 'MP', 'PR', 'VI'];

export const filterUSStatesAndTerritories = (states) =>
  states.filter(
    (st) =>
      st.isoCountryCode2 === 'US' &&
      // use inclusion rather than exclusion to simplify future maintenance
      [...US_STATE_CODES, ...US_TERRITORY_CODES].includes(st.stateCode),
  );
